<ng-multiselect-dropdown [placeholder]="'Grupo(s)'" [settings]="dropdownSettings" [data]="dropdownList" appendTo="body"
    [(ngModel)]="selectedItems" (onSelect)="changeItems()" (onDeSelect)="changeItems()" (onSelectAll)="allItems()"
    (onDeSelectAll)="anyItems()">
</ng-multiselect-dropdown>